const empty = name => v => !!v || `${name} alanı boş olamaz!`;
const digit = name => v => /^[0-9]+$/.test(v) || `${name} alanı sadece rakamlardan oluşabilir!`;
const email = v => /.+@.+/.test(v) || 'E-mail geçerli değil.';
const selection = (name = '') => v => (function () {
  return Object.isObject(v) && Object.isEmpty(v) ? `${name} alanında seçim yapmanız gerekmektedir!` : true;
}());
const phone = (masked = false) => v => (masked ? /^[0-9]+$/.exec(v).input.length === 11 || 'Geçersiz Telefon Numarası' : v.length === 16 || 'Geçersiz Telefon Numarası');

// if any of the given values is equals to false value, gives error
const required = ({ falseValues, message }) => val => !falseValues.some(falseValue => falseValue === val) || message;

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$rules = {
      empty,
      digit,
      selection,
      phone,
      email,
      required,
    };
  },
};
